export default "__VITE_ASSET__CkdwjHHp__"